import { render, staticRenderFns } from "./crudOperations.vue?vue&type=template&id=4c898eb5"
import script from "./crudOperations.vue?vue&type=script&lang=js"
export * from "./crudOperations.vue?vue&type=script&lang=js"
import style0 from "./crudOperations.vue?vue&type=style&index=0&id=4c898eb5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports